import { HeaderSearchSelection } from '@upright/common/model/search/types';
import { getTeamSession, loadSearchFilter } from '@upright/ui/common/generic/utilities/storage';
import { createContext, useContext } from 'react';

interface SearchContextProps {
  filter: HeaderSearchSelection | undefined;
}

const SearchContext = createContext<SearchContextProps>({
  filter: getTeamSession() ? loadSearchFilter() : undefined,
});

export function useHeaderSearchContext() {
  return useContext(SearchContext);
}
